var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{staticClass:"preview-image-styles",attrs:{"max-width":_vm.maxWidth,"max-height":_vm.maxHeight,"src":_vm.src,"contain":"","alt":"preview-image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }